import React, { useContext } from "react";
import { ProductsContext } from "../../../utils/stateHandlers/contexts";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

export default function SpecialInstructions() {
  const { productDispatch } = useContext(ProductsContext);
  return (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        Special Instructions
      </Typography>
      <TextField
        color="primary"
        variant="outlined"
        size="small"
        sx={{
          width: "100%",
          margin: "unset",
        }}
        onChange={(e) => {
          productDispatch({
            type: "setSpecialInstructions",
            payload: e.target.value,
          });
        }}
        inputProps={{
          style: {
            fontSize: 15,
            paddingBottom: 100,
          },
        }}
      />
    </Stack>
  );
}
